export const STORAGE_KEYS = {
  token: 'kwanza-tukule-token',
  refreshToken: 'kwanza-tukule-refresh-token',
  user: 'kwanza-tukule-user',
}
